/**
 * UUID Generator - Browser Compatible
 * Polyfill for crypto.randomUUID() for older browsers
 */

/**
 * Generate a UUID v4 (random)
 * Works in all browsers, including Safari private mode
 */
export function generateUUID(): string {
    // Try native crypto.randomUUID() first (fastest)
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }

    // Fallback: Manual UUID generation (RFC 4122 compliant)
    // Format: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

/**
 * Generate a short unique ID (8 characters)
 * Useful for order numbers, SKUs, etc.
 */
export function generateShortId(): string {
    return Math.random().toString(36).substring(2, 10).toUpperCase();
}

/**
 * Generate a numeric ID with timestamp
 * Useful for order IDs
 */
export function generateNumericId(): string {
    return `${Date.now()}-${Math.floor(Math.random() * 10000)}`;
}
